module.exports = __webpack_public_path__ + "static/media/banner-slider-img4.163f5789.f0552edb.png";